import axios from "axios";
// 给请求地址前加一个"/api"，在请求头中添加Token

// const instance = axios.create({
//   baseURL: "/api",
// });
// // 添加返回拦截器，直接获取返回内容的data
// instance.interceptors.response.use((res) => {
//   return res.data;
// });

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
// ---------------------------------------------

const instance = axios.create({
  baseURL: API_BASE_URL, // 使用动态的 baseURL
  withCredentials: true,
  timeout: 10000, // 10秒超时
});
// 添加返回拦截器，直接获取返回内容的data
instance.interceptors.response.use((res) => {
  return res.data;
});
//文件上传方法
// export const uploadFile = (url, formData, onUploadProgress) => {
//   return instance.post(url, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//     onUploadProgress,
//   });
// };
export const uploadFile = (url, formData) => {
  return instance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
